/* Amlove Memories — V2 interactions for Horizon. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noMotion = reduce || document.documentElement.classList.contains('am-no-motion');
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function qsa(root, sel) { return root.querySelectorAll(sel); }

  /* ---------- Memory Studio ---------- */
  function initStudio(root) {
    each(qsa(root, '[data-am-studio]'), function (studio) {
      if (studio.__amInit) return; studio.__amInit = true;
      var tabs = studio.querySelectorAll('[data-am-tab]');
      var scenes = studio.querySelectorAll('[data-am-scene]');
      var layers = studio.querySelectorAll('[data-am-layer]');
      var line = studio.querySelector('[data-am-tabline]');
      var tabbar = studio.querySelector('[data-am-tabbar]');
      var capEl = studio.querySelector('[data-am-cap]');
      var hEl = studio.querySelector('[data-am-heading]');
      var dEl = studio.querySelector('[data-am-desc]');
      var linkEl = studio.querySelector('[data-am-link]');
      var section = studio.closest('[data-am-veil-target]') || studio;
      var current = 0, timer = null;
      if (!tabs.length) return;

      function placeLine() {
        var sel = tabs[current];
        if (!line || !sel) return;
        line.style.width = sel.offsetWidth + 'px';
        line.style.transform = 'translateX(' + sel.offsetLeft + 'px)';
      }
      function set(i, focus) {
        current = (i + tabs.length) % tabs.length;
        var t = tabs[current];
        each(tabs, function (b, j) { b.setAttribute('aria-selected', j === current ? 'true' : 'false'); b.tabIndex = j === current ? 0 : -1; });
        each(scenes, function (s, j) { s.classList.toggle('is-on', j === current); });
        each(layers, function (s, j) { s.classList.toggle('is-on', j === current); });
        if (t.dataset.veil) section.style.backgroundColor = t.dataset.veil;
        placeLine();
        if (tabbar && tabbar.scrollWidth > tabbar.clientWidth) tabbar.scrollLeft = t.offsetLeft - 24;
        if (focus) t.focus();
        var outs = [capEl, hEl, dEl].filter(Boolean);
        outs.forEach(function (el) { el.classList.add('is-out'); });
        clearTimeout(timer);
        timer = setTimeout(function () {
          var tpl = t.querySelector('template');
          if (tpl) {
            var frag = tpl.content;
            var c = frag.querySelector('[data-cap]'), h = frag.querySelector('[data-heading]'), d = frag.querySelector('[data-desc]');
            if (capEl && c) capEl.innerHTML = c.innerHTML;
            if (hEl && h) hEl.innerHTML = h.innerHTML;
            if (dEl && d) dEl.innerHTML = d.innerHTML;
          }
          if (linkEl && t.dataset.link) linkEl.setAttribute('href', t.dataset.link);
          outs.forEach(function (el) { el.classList.remove('is-out'); });
        }, noMotion ? 0 : 220);
      }
      each(tabs, function (b, i) { b.addEventListener('click', function () { set(i); }); });
      if (tabbar) tabbar.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); set(current + (e.key === 'ArrowRight' ? 1 : -1), true); }
      });
      var stack = studio.querySelector('[data-am-stack]'), sx = null;
      if (stack) {
        stack.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stack.addEventListener('touchend', function (e) {
          if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) set(current + (dx < 0 ? 1 : -1));
        });
      }
      // Keep references so the theme editor can release this studio when the section is re-rendered
      if (window.ResizeObserver && tabbar) { studio.__amRO = new ResizeObserver(placeLine); studio.__amRO.observe(tabbar); }
      if (document.readyState !== 'complete') { studio.__amLoad = placeLine; window.addEventListener('load', placeLine, { once: true }); }
      studio.__amSet = set;
      set(0);
    });
  }

  /* ---------- Polaroid flip ---------- */
  function initFlip(root) {
    each(qsa(root, '[data-am-flip]'), function (btn) {
      if (btn.__amInit) return; btn.__amInit = true;
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    });
  }

  /* ---------- Parallax (hero collage) ---------- */
  var parallaxEls = [], ticking = false;
  function initParallax(root) {
    if (noMotion) return;
    each(qsa(root, '[data-am-depth]'), function (el) {
      if (el.__amInit) return; el.__amInit = true; parallaxEls.push(el);
      el.addEventListener('animationend', function () { el.classList.remove('am-develop'); });
    });
  }
  function onScroll() {
    if (!parallaxEls.length || ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.pageYOffset;
      if (y > 1600) return;
      parallaxEls.forEach(function (el) {
        var d = parseFloat(el.getAttribute('data-am-depth')) || 0;
        var rot = el.getAttribute('data-am-rotate') || '';
        el.style.transform = 'translate3d(0,' + (-y * d).toFixed(1) + 'px,0)' + (rot ? ' rotate(' + rot + 'deg)' : '');
      });
    });
  }

  /* ---------- Reveal on scroll (content stays visible without JS) ---------- */
  var io = null;
  function initReveal(root) {
    if (noMotion || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('is-pending'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    each(qsa(root, '.am-reveal'), function (el) {
      if (el.__amInit) return; el.__amInit = true;
      if (el.getBoundingClientRect().top > window.innerHeight * 0.95) { el.classList.add('is-pending'); io.observe(el); }
    });
  }
  var rvTick = false;
  function revealCheck() {
    if (rvTick) return; rvTick = true;
    requestAnimationFrame(function () {
      rvTick = false;
      each(document.querySelectorAll('.am-reveal.is-pending'), function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.remove('is-pending');
      });
    });
  }

  /* ---------- Slim / Tough segmented control ---------- */
  function placeKnob(g) {
    var k = g.querySelector('.am-seg__knob'), on = g.querySelector('[aria-pressed="true"]');
    if (!k || !on || !on.offsetWidth) return;
    k.style.width = on.offsetWidth + 'px';
    k.style.transform = 'translateX(' + (on.offsetLeft - 4) + 'px)';
  }
  function initSeg(root) {
    each(qsa(root, '[data-am-seg]'), function (g) {
      if (g.__amInit) return; g.__amInit = true;
      var scope = g.closest('[data-am-seg-scope]') || document;
      var desc = scope.querySelector('[data-am-seg-desc]');
      each(g.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function () {
          each(g.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var tough = b.getAttribute('data-style') === 'tough';
          each(scope.querySelectorAll('[data-am-seg-case]'), function (c) { c.classList.toggle('is-tough', tough); });
          if (desc) desc.textContent = b.getAttribute('data-desc') || '';
          placeKnob(g);
        });
      });
      placeKnob(g);
      if (window.ResizeObserver) new ResizeObserver(function () { placeKnob(g); }).observe(g);
    });
  }

  /* ---------- FAQ topics ---------- */
  function initFaq(root) {
    each(qsa(root, '[data-am-faq]'), function (faq) {
      if (faq.__amInit) return; faq.__amInit = true;
      var btns = faq.querySelectorAll('[data-am-topic]'), groups = faq.querySelectorAll('[data-am-group]');
      each(btns, function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-am-topic');
          each(btns, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          each(groups, function (g) { g.hidden = g.getAttribute('data-am-group') !== t; });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initStudio(root); initFlip(root); initParallax(root); initReveal(root); initSeg(root); initFaq(root);
    onScroll();
  }

  window.addEventListener('scroll', function () { onScroll(); revealCheck(); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor support */
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target; if (!root || !root.querySelectorAll) return;
    each(qsa(root, '[data-am-studio]'), function (studio) {
      if (studio.__amRO) { studio.__amRO.disconnect(); studio.__amRO = null; }
      if (studio.__amLoad) { window.removeEventListener('load', studio.__amLoad); studio.__amLoad = null; }
      studio.__amSet = null;
    });
    parallaxEls = parallaxEls.filter(function (el) { return !root.contains(el); });
    if (io) each(qsa(root, '.am-reveal'), function (el) { io.unobserve(el); });
  });
  document.addEventListener('shopify:section:load', function (e) { parallaxEls = parallaxEls.filter(function (el) { return document.contains(el); }); init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[data-am-tab]') : null;
    if (!tab) return;
    var studio = tab.closest('[data-am-studio]');
    if (studio && studio.__amSet) studio.__amSet(Array.prototype.indexOf.call(studio.querySelectorAll('[data-am-tab]'), tab));
  });
})();
